/* Route an existing optional APO photo control without replacing its uploader. */
(() => {
  'use strict';
  const boot=()=>{
    const marker=document.querySelector('[data-sc-optional-photo-handle]');
    const handles=new Set(['all-in-one-cover','dust-cover','sauna-cover-with-thermal-cover','insulated-thermal-sauna-cover','thermal-cover','custom-barrel-sauna-cushion','sauna-cushion','lumbar-cushions','one-person-sauna-cushion','sauna-cushion-golden-designs','sauna-cushion-health-mate-saunas','sauna-cushion-jacuzzi-saunas-clearlight-saunas','sauna-cushion-sunlighten','throw-pillows']);
    if(!handles.has(marker?.dataset.scOptionalPhotoHandle))return;
    const product=document.getElementById('ProductSection');
    const form=product?.querySelector('form[action="/cart/add"]');
    if(!form)return;
    let queued=false;
    const update=()=>{
      queued=false;
      const pages=[...product.querySelectorAll('[data-sc-order-page]')];
      const target=pages[3]?.querySelector('[data-sc-order-fields]');
      const options=[...form.querySelectorAll('.mw-option')].filter(option=>
        option.querySelector('.mw-text--style-strong')?.textContent.replace(/\s+/g,' ').trim()==='Photo of your sauna (optional)');
      if(!target||options.length!==1)return;
      const option=options[0];
      if(option.classList.contains('mw-option--required') || !option.querySelector('input[type="file"]'))return;
      if(option.parentElement!==target)target.append(option);
    };
    const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};
    new MutationObserver(schedule).observe(form,{childList:true,subtree:true});
    schedule();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
